import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Button } from "antd";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/eye.svg";
import { ReactComponent as CopyIcon } from "../../../assets/svgs/file-icon.svg";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import { convertRoleType, formatDate } from "../../../utils/UtilService";
import { useDebounce } from "../../../hooks/debouncing";
const StandardSurveyForm = ({
  setOpenAssignedForm,
  projectId,
  setAssignedFormtype,
  setSelectedRole,
  projectSetup,
}) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);  // current active page
const [pageSize, setPageSize] = useState(5);       // items per page
const [totalRecords, setTotalRecords] = useState(0); // total available items
  // Static table data
  // const tableData = useMemo(
  //   () => [
  //     {
  //       key: "1",
  //       serial: 1,
  //       formName: "Survey Form A",
  //       assignedOn: "2024-07-20",
  //       action: (
  //         <div className="flex gap-3">
  //           <EyeIcon
  //             style={{ fontSize: "18px", cursor: "pointer" }}
  //             onClick={() => navigate(`/organization/assigned-form/view/1`)}
  //           />
  //           <CopyIcon style={{ fontSize: "18px", cursor: "pointer" }} />
  //         </div>
  //       ),
  //     },
  //     {
  //       key: "2",
  //       serial: 2,
  //       formName: "Survey Form B",
  //       assignedOn: "2024-07-21",
  //       action: (
  //         <div className="flex gap-3">
  //           <EyeIcon
  //             style={{ fontSize: "18px", cursor: "pointer" }}
  //             onClick={() => navigate(`/organization/assigned-form/view/2`)}
  //           />
  //           <CopyIcon style={{ fontSize: "18px", cursor: "pointer" }} />
  //         </div>
  //       ),
  //     },
  //   ],
  //   [navigate]
  // );
 const debouncedSearch = useDebounce(searchTerm, 500);
const getStandardForms = async (projectId) => {
  try {
    const response = await getApi({
      apiUrl: API_URLS.GET_STANDARD_FORM_BY_PROJECTID(
        projectId,
        debouncedSearch,
        currentPage,
        pageSize
      ),
    });

    if (response.success) {
      const { records, total, limit, pageNo, totalPages } = response.data;

      // ✅ update state with proper backend values
      setPageSize(limit);
      setTotalRecords(total);
      setCurrentPage(pageNo);

      const data = records.map((item, index) => ({
        key: item._id,
        serial: (pageNo - 1) * limit + (index + 1), // correct serial numbering
        formName: item.title,
        assignedOn: formatDate(item.AssignedOn),
        roleType: (
          <div className="uppercase">
            {convertRoleType(item.role_type).join(", ")}
          </div>
        ),
        action: (
          <div className="flex gap-3 justify-center items-center">
            <EyeIcon
              style={{ fontSize: "18px", cursor: "pointer" }}
              onClick={() => navigate(`/standard-forms/${item._id}/all-questions`)}
            />
          </div>
        ),
      }));

      setTableData(data);
    }
  } catch (error) {
    console.error("Error in fetching standard form data", error);
  }
};

const handlePageChange = useCallback((page, pageSize) => {
   setCurrentPage(page);
  setPageSize(pageSize);
}, []);
  // Table headers
  const surveyHeader = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Name", key: "formName" },
      { label: "Assigned On", key: "assignedOn" },
      { label: "Role Type", key: "roleType" },
      { label: "Action", key: "action" },
    ],
    []
  );

  // Search functionality
  // const handleSearch = useCallback((searchTerm) => {
  //   setSearchTerm(searchTerm.toLowerCase());
  // }, []);

  // Sorting functionality
  const handleSort = useCallback((key, order) => {
    setSortBy(key);
    setSortOrder(order);
  }, []);

  // Filtered data based on search term
  // const filteredData = useMemo(() => {
  //   if (!searchTerm) return tableData;
  //   return tableData.filter((item) =>
  //     surveyHeader.some((header) => {
  //       if (header.key === "action") return false;
  //       return String(item[header.key]).toLowerCase().includes(searchTerm);
  //     })
  //   );
  // }, [tableData, searchTerm, surveyHeader]);

  useEffect(() => {
    if (projectId) {
      getStandardForms(projectId);
    }
  }, [projectId, projectSetup, debouncedSearch, pageSize,currentPage]);
  return (
    <div>
      {/* Header Section */}
      <div className="flex justify-between mx-8 mt-4 font-medium">
        <div className="flex gap-16">
          <p className="text-[#06513D] pt-2">STANDARD SURVEY FORMS </p>
          <SearchBar width="300px" onSearch={(value)=>{setSearchTerm(value);
            setCurrentPage(1)
          }} />
        </div>
        <div>
          <Button
            type="primary"
            style={{
              background: "#06513D",
              height: "50px",
              width: "150px",
              borderRadius: "10px",
            }}
            className="text-xs font-light hover:!bg-[#387464]"
            onClick={() => {
              setOpenAssignedForm(true);
              setAssignedFormtype("standard");
              setSelectedRole(null);
            }}
          >
            Assigned Form
          </Button>
        </div>
      </div>

      {/* Table Section */}
      <Tables
  data={tableData}
  headers={surveyHeader}
  sortBy={sortBy}
  sortOrder={sortOrder}
  total={totalRecords}
  current={currentPage}
  pageSize={pageSize}
  onChange={handlePageChange}
/>
    </div>
  );
};

export default React.memo(StandardSurveyForm);
